import { render, staticRenderFns } from "./CreateCampaignCoverImageUpload.vue?vue&type=template&id=c33fc706&scoped=true"
import script from "./CreateCampaignCoverImageUpload.vue?vue&type=script&lang=js"
export * from "./CreateCampaignCoverImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignCoverImageUpload.vue?vue&type=style&index=0&id=c33fc706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33fc706",
  null
  
)

export default component.exports